__turbopack_context__.v({
  "arrow": "aQ3gfq_arrow",
  "item": "aQ3gfq_item",
});
